export const Messages_ru  = {
    MEME_FOR_FRIENDS: 'Мем для друзей',
    MEME_PUBLIC: 'Публичный мем',
    MEME_PRIVATE: 'Приватный мем',

    SHOW_FIRST: 'Показывать сначала'
};